exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.category[data-v-db36e830] {\n    border-top-left-radius: 1em;\n    border-top-right-radius: 1em;\n}\n.bottom-task-left[data-v-db36e830] {\n\n\n    border-bottom-left-radius: 1em;\n}\n.bottom-task-right[data-v-db36e830] {\n\n\n    border-bottom-right-radius: 1em;\n}\n", ""]);

// exports
